module.exports = __webpack_public_path__ + "img/EU Logo quer grau.4a9d3667.svg";